<template>
<store-count-table product-type="产品"></store-count-table>
</template>

<script>
import StoreCountTable from '@/views/modules/StoreManager/common/store-count-table'
export default {
  name: 'product',
  components:{StoreCountTable}
}
</script>

<style scoped>

</style>
